// value: key
// label: name
// hide: 显示隐藏        true: 隐藏， false  展示
// disabled： 是否禁用   true: 禁用

// 静态字典文件
const dict = {
  DELIVERY_SHAPE: [
    { value: 1, label: '线上视频交付' },
    { value: 2, label: '线下授课交付' }
  ],
  DELIVERY_STATUS: [
    { value: 1, label: '待交付' },
    { value: 2, label: '交付中' },
    { value: 3, label: '延期交付' },
    { value: 4, label: '锁定交付' },
    { value: 5, label: '已交付' },
    { value: 6, label: '已关闭' }
  ],
  LOGISTICS_STATUS_LIST: [
    { label: '未付款', value: -1 },
    { label: '订单审核', value: 0 },
    { label: '打单配货', value: 1 },
    { label: '验货', value: 2 },
    { label: '称重', value: 3 },
    { label: '待发货', value: 4 },
    { label: '财审', value: 5 },
    { label: '已发货', value: 8 },
    { label: '交易成功', value: 9 },
    { label: '异常结束', value: 11 },
    { label: '异常处理', value: 12 },
    { label: '配货中', value: 13 },
    { label: '预售', value: 14 },
    { label: '打包', value: 15 },
    { label: '待处理', value: 16 },
    { label: '交易关闭', value: 10 },
    { label: '拣货', value: 19 }
  ],
  SORT_TYPE_LIST: [
    { value: 0, label: '从旧到新' },
    { value: 1, label: '从新到旧' }
  ],
  CONTENT_DIMENSION_TYPE:[
    { value: 0, label: '选择替换包含关键词全部内容' },
    { value: 1, label: '只替换关键词' }
  ],
  GOODS_STATUS: [
    { value: 0, label: '图片' },
    { value: 1, label: '音频' },
    { value: 2, label: '视频' },
    { value: 3, label: '专栏' },
    { value: 4, label: '大专栏' },
    { value: 5, label: '线下课程' },
    { value: 6, label: '直播专栏' },
    { value: 7, label: '套餐课' },
    { value: 8, label: '训练营' }
  ],
  EMOTION_STATUS: [
    { value: 'happy', label: '高兴' },
    { value: 'sad', label: '悲伤' },
    { value: 'angry', label: '愤怒' },
    { value: 'fearful', label: '害怕' },
    { value: 'disgusted', label: '厌恶' },
    { value: 'surprised', label: '惊讶' },
    { value: 'neutral', label: '中性' }
  ],
  IS_FEATURED: [
    {
      value: '',
      label: '全部'
    },
    {
      value: 1,
      label: '精选'
    },
    {
      value: 0,
      label: '非精选'
    }
  ],
  DELIVERY_ONE_STATUS: [
    { value: 1, label: '待交付' },
    { value: 2, label: '交付中' },
    { value: 3, label: '已交付' },
    { value: 4, label: '已关闭' },
    { value: 5, label: '锁定交付' }
  ],
  IS_AVAILABLE_STATUS: [
    { value: 0, label: '有效' },
    { value: 1, label: '无效' }
  ],
  IS_ADDRESS_TYPE: [
    { value: 2, label: '已填' },
    { value: 1, label: '未填' }
  ],
  EXPORT_TYPE: [
    { value: '', label: '全部分类' },
    { value: 2, label: '表格导出' },
    { value: 1, label: '页面查看' }
  ],
  PACKAGE_DELIVERY_ONE_STATUS: [
    { value: 1, label: '待交付' },
    { value: 2, label: '交付中' },
    { value: 3, label: '延期交付' },
    { value: 4, label: '锁定交付' },
    { value: 5, label: '已交付' },
    { value: 6, label: '已关闭' },
    { value: 7, label: '其它' }
  ],
  OFFLINE_DELIVERY_ONE_STATUS: [
    { value: 1, label: '待交付' },
    { value: 2, label: '已入班' },
    { value: 3, label: '延期交付' },
    { value: 4, label: '锁定交付' },
    { value: 5, label: '已交付' },
    { value: 6, label: '已关闭' },
    { value: 7, label: '其它' }
  ],
  ADD_WECHAT_STATUS: [
    { value: 1, label: '未加企微' },
    { value: 2, label: '未加个微' },
    { value: 3, label: '企微和个微均未加上' }
  ],
  TIME_TYPE: [
    { value: 'addGwTime', label: '加个微时间' },
    { value: 'addQwTime', label: '加企微时间' }
  ],
  TIME_LIVE_TYPE: [
    { value: 0, label: '开播时间' },
    { value: 1, label: '创建时间' }
  ],
  ADD_QW_AND_GW_LIST: [
    { value: 1, label: '已加企微' },
    { value: 9, label: '已加企微自动' },
    { value: 10, label: '已加企微手动' },
    { value: 2, label: '已加个微' },
    { value: 3, label: '已加企微或个微' },
    { value: 4, label: '已加企微和个微' },
    { value: 5, label: '未加企微' },
    { value: 6, label: '未加个微' },
    { value: 7, label: '企微个微均未加' }
  ],
  WX_TYPE: [
    { value: 'wechatNickName', label: '微信昵称' },
    { value: 'remark', label: '微信备注名' }
  ],
  FOLLOW_USER_TYPE: [
    { value: 'followUserId', label: '跟进人' },
    { value: 'enrollmentTeacherId', label: '招生老师' }
  ],
  INHERIT_STATUS: [
    { value: 1, label: '离职继承' },
    { value: 0, label: '在职继承' },
    { value: 2, label: '不继承' }
  ],
  CLASS_STATUS: [
    { value: 0, label: '未到课' },
    { value: 1, label: '已到课' }
  ],
  GOODS_TYPE: [
    { value: 0, label: '视频课' },
    { value: 1, label: '训练营' },
    { value: 2, label: '线下课' },
    { value: 3, label: '组合课' },
    { value: 4, label: '图书' }
  ],
  TASK_TYPE: [
    { value: 'broadcast', label: '群发同内容' },
    { value: 'broadcast_diff', label: '群发异内容' },
    { value: 'sop_message', label: '单发' }
  ],
  WXCOM_LOGIN_STATUS: [
    { value: 1, label: '已登录' },
    { value: 0, label: '未登录' },
    { value: 2, label: '登录中' }
  ],
  TASK_STATUS: [
    { value: 0, label: '待执行' },
    { value: 1, label: '执行中' },
    { value: 2, label: '已完成' },
    { value: 3, label: '失败' },
    { value: 4, label: '已取消' },
    { value: 5, label: '企微未登录' },
    { value: 6, label: '无联系人' },
    { value: 7, label: '待查询联系人' },
    { value: 9, label: '已暂停' },
  ],
  CRMWX_USER_TYPE: [
    { value: 1, label: '微信用户' },
    { value: 2, label: '企微用户' }
  ],
  TASK_PRIORITY: [
    { value: 1, label: '高' },
    { value: 2, label: '中' },
    { value: 3, label: '低' }
  ],
  COURSE_WORK_STATUS: [
    { value: 1, label: '未收集' },
    { value: 2, label: '已收集' }
  ],
  VIDEO_SOURCE: [
    { value: 1, label: '手动上传' },
    { value: 2, label: '初剪视频' },
    { value: 3, label: '直播回放' }
  ],
  RECORDINGTYPE: [
    { value: 0, label: '云端录制' },
    { value: 1, label: '回放合成' }
  ],
  CORERT_STATUS: [
    { value: 0, label: '排队中' },
    { value: 1, label: '转码中' },
    { value: 2, label: '转码成功' },
    { value: 3, label: '转码失败' }
  ],
  SCHEDULE_TYPE: [
    { value: 'customized', label: '定制' },
    { value: 'others', label: '其他' }
  ],
  VIDEO_TYPE_SOURCE: [
    { value: 1, label: '已启用' },
    { value: 2, label: '已禁用' }
  ],
  SENSITIVE_DETECTION_STATUS: [
    { value: 0, label: '未检测' },
    { value: 1, label: '检测中' },
    { value: 2, label: '通过' },
    { value: 3, label: '敏感词风险' }
  ],
  URL_TYPE_SOURCE: [
    { value: 1, label: '启用' },
    { value: 0, label: '未启用' }
  ],
  DOMAIN_TYPE: [
    { value: 'main', label: '落地页主域名' },
    { value: 'middle', label: '中间域名' },
    { value: 'short', label: '短链域名' }
  ],
  SUCCESS_TYPE: [
    { value: 1, label: '成功' },
    { value: 2, label: '失败' }
  ],
  OKISNO_TYPE: [
    { value: 1, label: '是' },
    { value: 0, label: '否' }
  ],

  DELIVERY_REASON: [
    { value: '确定未交付', label: '确定未交付' },
    { value: '代签误操作', label: '代签误操作' }
  ],
  SDK_MODE  : [
    { value: 'auto', label: '自动回复' },
    { value: 'manual', label: '人工回复' }
  ],
  LIVE_TYPE_MONEY: [
    { value: '', label: '全部' },
    { value: 1, label: '免费' },
    { value: 2, label: '付费' }
  ],
  COMMODITY_SORT: [
    { label: '文件名称（A-Z）', value: 0 },
    { label: '文件名称（Z-A）', value: 1 },
    { label: '上传时间（新-旧）', value: 2 },
    { label: '上传时间（旧-新）', value: 3 }
  ],
  LIVE_STATE_OPTION: [
    { label: '未开始', value: 0 },
    { label: '直播中', value: 1 },
    { label: '直播暂停', value: 2 },
    { label: '直播异常', value: 3 },
    { label: '直播结束', value: 9 },
    { label: '加载中', value: '-1' }
  ],
  LIVE_MODE_OPTION: [
    { label: '真人直播', value: 'PERSON_LIVE', icon: 'zibo' },
    { label: '数字直播', value: 'AI_LIVE', icon: 'zhinengzhibo' }
  ],
  ORDER_STATUS: [
    { label: '未处理', value: 0 },
    { label: '退款中', value: 1 },
    { label: '已退款', value: 2 },
    { label: '已关闭', value: 3 },
    { label: '退款异常', value: 4 },
    { label: '处理中', value: 5 },
    { label: '商家拒绝退款', value: 6 },
    { label: '部分退款', value: 7 }
  ],
  CONTACT_TYPE: [
    { label: '手机号', value: 1 },
    { label: '邮箱号', value: 2 }
  ],
  TIME_STATUS: [
    { label: '年', value: 1 },
    { label: '月', value: 2 },
    { label: '天', value: 3 }
  ],
  OERDER_TYPE: [
    { label: '订单号', value: 'orderNo' },
    { label: '售后单号', value: 'afterSaleNo' },
    { label: '交易单号', value: 'transactionId' },
    { label: '买家昵称', value: 'userName' },
    { label: '买家手机号', value: 'userPhone' },
    { label: '买家邮箱', value: 'email' },
    { label: '用户ID', value: 'userId' },
    { label: '商品名称', value: 'goodsName' }
  ],
  ACTION_TYPE: [
    { label: '数据同步', value: 1 },
    { label: '延期', value: 2 },
    { label: '关闭交付', value: 3 },
    { label: '换人就读', value: 4 }
  ],
  // 跟进状态
  FOLLOW_STATUS: [
    { label: '已加个微待通过', value: 1 },
    { label: '不需要', value: 2 },
    { label: '在忙', value: 3 },
    { label: '未接', value: 4 },
    { label: '意向客户', value: 5 },
    { label: '未知', value: 6 },
    { label: '未接2', value: 7 },
    { label: '未接3', value: 8 },
    { label: '电话搜不到微信', value: 9 },
    { label: '已发短信', value: 10 }
  ],
  DYNAMIC_STATUS: [
    { label: '人工外呼', value: 4 },
    { label: '跟进记录', value: 1 },
    { label: 'AI外呼', value: 2 },
    { label: '短信', value: 3 }
  ],
  ADD_W_LIST: [
    {
      label: '已加',
      value: 1
    },
    {
      label: '未加',
      value: 0
    }
  ],
  // COMMENT_TYPE: [
  //   {
  //     value: 1,
  //     label: '有图片'
  //   },
  //   {
  //     value: 2,
  //     label: '有内容'
  //   }
  // ],
  COMMENT_TYPE: [
    {
      value: 'userPhone',
      label: '电话'
    },
    {
      value: 'userName',
      label: '姓名'
    },
    {
      value: 'email',
      label: '邮箱'
    }
  ],
  EVALUATION_LEVEL: [
    {
      value: 1,
      label: '好评'
    },
    {
      value: 2,
      label: '中评'
    },
    {
      value: 3,
      label: '差评'
    }
  ],
  AUDITOR_STATE: [
    {
      value: 1,
      label: '未审核'
    },
    {
      value: 2,
      label: '审核通过'
    },
    {
      value: 3,
      label: '审核未通过'
    }
  ],
  LEVEL_GRADE: [
    {
      value: 1,
      label: '好'
    },
    {
      value: 2,
      label: '中'
    },
    {
      value: 3,
      label: '差'
    }
  ],
  ASSIGNMENTRULE_TYPE: [
    {
      value: 1,
      label: '按权重分配'
    }
  ],
  PRIORITY_STATUS: [
    {
      value: 1,
      label: '高'
    },
    {
      value: 2,
      label: '中'
    },
    {
      value: 3,
      label: '低'
    }
  ],
  CONDITION_TYPE: [
    {
      value: 1,
      label: '按第三方店铺商品'
    },
    {
      value: 2,
      label: '按伏羲云商品'
    },
    {
      value: 3,
      label: '按伏羲云商品类型'
    }
  ],
  ORDERSTATUS_OPTIONS: [
    { label: '未支付', value: 1 },
    { label: '支付成功', value: 2 },
    { label: '超时已关闭', value: 3 },
    { label: '用户已取消', value: 4 },
    { label: '退款中', value: 5 },
    { label: '部分退款', value: 6 },
    { label: '全部退款', value: 7 },
    { label: '交易结束', value: 8 },
    { label: '没有向第三方发起支付请求', value: 9 },
    { label: '退款金额异常', value: 10 }
  ],
  liveRoomMode: [
    {
      value: 'PERSON_LIVE',
      label: '真人直播'
    },
    {
      value: 'AI_LIVE',
      label: '智能直播'
    },
    {
      value: 'DIGITAL_PERSON_LIVE',
      label: '数字人直播'
    }
  ],
  singleLectureType: [
    {
      value: 1,
      label: '课程只有本老师'
    },
    {
      value: 0,
      label: '课程含有本老师'
    }
  ],
  STUDENT_LEVEL: [
    { label: 'A', value: 'A' },
    { label: 'B', value: 'B' },
    { label: 'C', value: 'C' },
    { label: 'D', value: 'D' },
    { label: 'E', value: 'E' }
  ],
  REFUND_JAM_STATUS: [
    { label: '未处理', value: 'pending' },
    { label: '已处理', value: 'success' }
  ],
  ORDER_CHANNELS: [
  { label: '抖店', value: 1 },
  { label: '快手小店', value: 2 },
  { label: '微店', value: 4 },
  { label: '小鹅通', value: 7 },
  { label: '视频号小店', value: 10 },
  { label: '枫叶小店', value: 11 },
  { label: '抖音小程序', value: 12 },
  { label: '直播间', value: 13 },
  { label: '平台自营', value: 14 },
  { label: '微信小程序', value: 15 },
  { label: '小红书', value: 16 },
  { label: '线下录单', value: 17 },
  { label: 'B站', value: 18 },
  { label: '百度小店', value: 20 }
]
}
export default dict
